import React from 'react';

class NoSearching extends React.Component {
  render() {
    return (
      <div className="col-12">
        <div className="row">
          <div className="col-8">
            <p>Nenhum produto foi encontrado</p>
          </div>
        </div>
      </div>
    );
  }
}

export default NoSearching;
